const NO = 'No';
const NOT_SURE = `I'm not sure`;
const YES = 'Yes';

export {
  NO,
  NOT_SURE,
  YES
};